// Archivo: assets/vaciarCarrito.js

// ─────────────────────────────────────────────────────────────────
// 0) Inyectar en <head> los estilos para los botones “No” y “Sí”
//    (con guard para no duplicar estilos)
// ─────────────────────────────────────────────────────────────────
;(function injectVaciarCSS() {
  if (document.getElementById('vaciar-css')) return; // evita inyectar 2 veces

  const css = `
    /* botón relleno + sweep */
    .button--sweep {
      position: relative;
      overflow: hidden;
      background-color: #011f2d;
      padding: 11px 60px;
      color: #ffffff;
      border: none;
      font-size: 16px;
      border-radius: 4px;
      cursor: pointer;
      transition: background-color 0.2s ease;
    }
    .button--sweep .sweep-layer {
      position: absolute;
      top: 0; left: 0;
      width: 0%; height: 100%;
      background-color: #0062EE;
      transition: width 0.4s ease;
      z-index: 0;
      border-radius: inherit;
    }
    .button--sweep .label {
      position: relative;
      z-index: 1;
    }
    .button--sweep:hover .sweep-layer {
      width: 100%;
    }

    /* botón outline para “No” */
    .button--outline {
      position: relative;
      background-color: transparent;
      color: #011f2d;
      border: 2px solid #011f2d;
      padding: 11px 60px;
      font-size: 16px;
      border-radius: 4px;
      cursor: pointer;
      transition: background-color 0.3s ease;
    }
    .button--outline:hover {
      background-color: rgba(1,31,45,0.1);
    }

    /* refuerzo específico por id (opcional) */
    #CartDrawer-ClearAll.button--sweep:hover .sweep-layer {
      width: 100% !important;
    }
  `;
  const style = document.createElement('style');
  style.id = 'vaciar-css';
  style.type = 'text/css';
  style.appendChild(document.createTextNode(css));
  document.head.appendChild(style);
})();

document.addEventListener('DOMContentLoaded', function () {
  // -------------------------------------------------------
  // 1) Formatear centavos a “$ 1,500.00 MXN”
  // -------------------------------------------------------
  function formatMoneyMXN(cents) {
    return (cents / 100).toLocaleString('es-MX', {
      style: 'currency',
      currency: 'MXN',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  }

  // ------------------------------------------------------------
  // 2) Actualiza el bloque “Envío gratis” dinámicamente
  // ------------------------------------------------------------
  function actualizarEnvioGratis(cartData) {
    const wbship = document.querySelector('.wbship');
    if (!wbship) return;

    const thresholdCents    = parseInt(wbship.dataset.shipThreshold, 10) || 0;
    const currentTotalCents = cartData.total_price || 0;
    const faltaCents        = Math.max(thresholdCents - currentTotalCents, 0);

    const wbshipWrapper = wbship.querySelector('.wbship_wrapper');
    const progressBar   = wbship.querySelector('.progress .determinate');

    if (wbshipWrapper) {
      if (currentTotalCents >= thresholdCents) {
        wbshipWrapper.classList.add('wbship_full_wrapper');
        wbshipWrapper.innerHTML = `
          <span style="display:inline-flex;align-items:center">
            <span class="icon-truck" style="margin-right:0.5em"></span>¡Envío GRATIS!
          </span>
        `;
      } else {
        wbshipWrapper.classList.remove('wbship_full_wrapper');
        wbshipWrapper.innerHTML = `
          Agrega más <b>${formatMoneyMXN(faltaCents)}</b> extra para envío GRATIS!
        `;
      }
    }

    if (progressBar) {
      const porcentaje = thresholdCents > 0
        ? Math.min((currentTotalCents / thresholdCents) * 100, 100)
        : 0;
      progressBar.style.width = `${porcentaje}%`;
    }
  }

  // ------------------------------------------------------------
  // 3) Inyectar “Carrito vacío” si el carrito queda en 0
  // ------------------------------------------------------------
  function mostrarCarritoVacio() {
    const drawerInner   = document.querySelector('.drawer__inner');
    const emptyTemplate = document.getElementById('CartDrawer-EmptyTemplate');
    if (!drawerInner || !emptyTemplate?.firstElementChild) return;

    const cartItemsContainer = drawerInner.querySelector('#CartDrawer-CartItems');
    if (cartItemsContainer) cartItemsContainer.innerHTML = '';

    const existingEmpty = drawerInner.querySelector('.drawer__inner-empty');
    if (existingEmpty) existingEmpty.remove();

    const cloneEmpty   = emptyTemplate.firstElementChild.cloneNode(true);
    const drawerHeader = drawerInner.querySelector('.drawer__header');
    if (drawerHeader) {
      drawerHeader.insertAdjacentElement('afterend', cloneEmpty);
    } else {
      drawerInner.insertAdjacentElement('afterbegin', cloneEmpty);
    }
  }

  // ---------------------------------------------------------
  // 4) Mostrar u ocultar botón “Vaciar Carrito”
  // ---------------------------------------------------------
  function ajustarVisibilidadBoton(cartData) {
    const btn = document.getElementById('CartDrawer-ClearAll');
    if (!btn) return;
    btn.style.display = cartData.item_count === 0 ? 'none' : 'block';
  }

  // ---------------------------------------------------
  // 5) Estilizar botón “Vaciar Carrito” (una sola vez)
  // ---------------------------------------------------
  function styleVaciarBtn() {
    const btn = document.getElementById('CartDrawer-ClearAll');
    if (!btn || btn.dataset.vacStyled === '1') return; // evita duplicar listeners
    btn.dataset.vacStyled = '1';

    // Limpia spans previos (si vinieran del Liquid)
    btn.innerHTML = '';

    // Estilos inline base (NO tocar display; lo maneja ajustarVisibilidadBoton)
    Object.assign(btn.style, {
      position:   'relative',
      overflow:   'hidden',
      backgroundColor: '#011f2d',
      color:          '#ffffff',
      border:         'none',
      padding:        '10px 65px',
      fontSize:       '16px',
      borderRadius:   '5px',
      cursor:         'pointer',
      textAlign:      'center'
    });

    // Crea la “sweep-layer”
    const sweep = document.createElement('span');
    sweep.className = 'sweep-layer';
    Object.assign(sweep.style, {
      position:      'absolute',
      top:           '0',
      left:          '0',
      width:         '0%',
      height:        '100%',
      backgroundColor: '#0062EE',
      transition:    'width 0.4s ease',
      zIndex:        '0',
      borderRadius:  'inherit'
    });
    btn.appendChild(sweep);

    // Crea el label centrado
    const label = document.createElement('span');
    label.className = 'label';
    label.textContent = 'Vaciar Carrito';
    Object.assign(label.style, {
      position: 'relative',
      zIndex:   '1'
    });
    btn.appendChild(label);
    // El hover lo maneja el CSS (.button--sweep:hover .sweep-layer)
    if (!btn.classList.contains('button--sweep')) btn.classList.add('button--sweep');
  }

  // ------------------------------------------------------------
  // 6) Modal de “¿Estás seguro?” antes de vaciar
  // ------------------------------------------------------------
  function abrirConfirmacionVaciar() {
    if (document.getElementById('VaciarModalOverlay')) return;

    const overlay = document.createElement('div');
    overlay.id = 'VaciarModalOverlay';
    Object.assign(overlay.style, {
      position: 'fixed', top: '0', left: '0',
      width: '100vw', height: '100vh',
      background: 'rgba(0,0,0,0.5)',
      zIndex: '2147483647',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    });

    const modal = document.createElement('div');
    modal.id = 'VaciarModal';
    Object.assign(modal.style, {
      background: '#fff',
      padding: '1.5rem',
      borderRadius: '8px',
      boxShadow: '0 2px 10px rgba(0,0,0,0.2)',
      maxWidth: '320px',
      width: '100%',
      textAlign: 'center'
    });

    const pregunta = document.createElement('p');
    pregunta.textContent = '¿Estás seguro de vaciar el carrito?';
    Object.assign(pregunta.style, {
      marginBottom: '1rem',
      fontSize: '16px',
      color: '#333'
    });

    const btnContainer = document.createElement('div');
    Object.assign(btnContainer.style, {
      display: 'flex',
      gap: '10px',
      justifyContent: 'space-between'
    });

    const btnNo = document.createElement('button');
    btnNo.textContent = 'No';
    btnNo.classList.add('button--outline');
    btnNo.addEventListener('click', () => overlay.remove());

    const btnSi = document.createElement('button');
    btnSi.classList.add('button--sweep');
    btnSi.innerHTML = `
      <span class="sweep-layer"></span>
      <span class="label">Sí</span>
    `;
    btnSi.addEventListener('click', () => {
      overlay.remove();
      vaciarCarrito();
    });

    btnContainer.appendChild(btnNo);
    btnContainer.appendChild(btnSi);
    modal.appendChild(pregunta);
    modal.appendChild(btnContainer);
    overlay.appendChild(modal);
    document.body.appendChild(overlay);
  }

  // ------------------------------------------------------
  // 7) Vaciar el carrito y recargar la página
  // ------------------------------------------------------
  function vaciarCarrito() {
    fetch('/cart/clear.js', {
      method: 'POST',
      credentials: 'same-origin'
    })
      .then(res => {
        if (!res.ok) return Promise.reject();
        window.location.reload();
      })
      .catch(err => console.error('Error al vaciar carrito:', err));
  }

  // ----------------------------------------------------
  // 8) Listener: clic en “Vaciar Carrito”
  // ----------------------------------------------------
  document.body.addEventListener('click', function (e) {
    const btn = e.target.closest('#CartDrawer-ClearAll');
    if (!btn || btn.style.display === 'none') return;
    abrirConfirmacionVaciar();
  });

  // ----------------------------------------------------
  // 9) Interceptar “Agregar al carrito” para recálculo y restyle
  // ----------------------------------------------------
  document.addEventListener('submit', function (e) {
  const form = e.target.closest('form[action^="/cart/add"]');
  if (!form) return;

  // Dejamos que el theme haga /cart/add.js
  // Luego refrescamos datos del carrito para tus UI hooks
  setTimeout(() => {
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(res => res.json())
      .then(cartData => {
        // 1) actualización de envío gratis
        actualizarEnvioGratis(cartData);
        // 2) mostrar/ocultar botón
        ajustarVisibilidadBoton(cartData);
        // 3) estilizar (guard evita repetir)
        styleVaciarBtn();
        })
      .catch(() => {});
    }, 400); // pequeño delay para dar tiempo al add
  }, true);

  // ---------------------------------------------------------
  // 10) Inicializar al cargar la página
  // ---------------------------------------------------------
  fetch('/cart.js', { credentials: 'same-origin' })
    .then(res => res.json())
    .then(cartData => {
      actualizarEnvioGratis(cartData);
      ajustarVisibilidadBoton(cartData);
      if (cartData.item_count === 0) mostrarCarritoVacio();
      styleVaciarBtn(); // style inicial del botón (guard evita repetir)
    })
    .catch(() => {});

  // 11) Vaciar Carrito en la página principal (cart page)
  const mainClearBtn = document.getElementById('CartPage-ClearAll');
  if (mainClearBtn) {
    mainClearBtn.addEventListener('click', () => {
      if (!confirm('¿Estás seguro de vaciar todo el carrito?')) return;
      fetch('/cart/clear.js', {
        method: 'POST',
        credentials: 'same-origin'
      })
      .then(res => {
        if (!res.ok) throw new Error('Error al vaciar el carrito');
        window.location.reload();
      })
      .catch(err => console.error(err));
    });
  }
});
